import { gql } from '@apollo/client'

const ALL_FILTER_CATEGORIES_EN = gql`
  query FilterCategoriesQuery {
    filterCategories_EN_LA {
      _id
      data {
        id
        doesAllowMultiple
        isDynamicCategory
        name
        filters {
          description
          id
          isActive
          information
        }
      }
    }
  }
`

const ALL_FILTER_CATEGORIES_ES = gql`
  query FilterCategoriesQuery {
    filterCategories_ES_LA {
      _id
      data {
        id
        doesAllowMultiple
        isDynamicCategory
        name
        filters {
          description
          id
          isActive
          information
        }
      }
    }
  }
`

const ALL_FILTER_CATEGORIES = {
  EN: ALL_FILTER_CATEGORIES_EN,
  ES: ALL_FILTER_CATEGORIES_ES,
}

export { ALL_FILTER_CATEGORIES }
